import { isHiddenCpf, removeMaskCpf } from '../cpf'
import { ParseEditUserProps } from './types/typeRequestParse'

function parseEditUser(request: ParseEditUserProps) {
  request.phone.type = parseInt(request.phone.type)
  if (isHiddenCpf(request.cpf)) {
    const { cpf, ...requestWithoutCpf } = request

    return requestWithoutCpf
  }

  request.cpf = removeMaskCpf(request.cpf)

  return request
}

export default parseEditUser
